import { get } from "jquery";
import $axios from "../../api";
import FileSaver from "file-saver";

const state = {
  isLoading: false,
  isLoadingLog: false,
  isLoadingFetch: false,
  createLoading: false,
  backupLoading: false,
  errors: "",
  isSuccess: false,
  receiptList: [],
  receiptLog: [],
  page: 1,
  statusList: [],
  methods: [],
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_LOADING_LOG(state, payload) {
    state.isLoadingLog = payload;
  },
  SET_LOADING_FETCH(state, payload) {
    state.isLoadingFetch = payload;
  },
  SET_CREATE_LOAD(state, payload) {
    state.createLoading = payload;
  },
  SET_BACKUP_LOADING(state, payload) {
    state.backupLoading = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_RECEIPT_LIST(state, payload) {
    state.receiptList = payload;
  },
  SET_RECEIPT_LOG(state, payload) {
    state.receiptLog = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_STATUS_LIST(state, payload) {
    state.statusList = payload;
  },
  SET_METHODS(state, payload) {
    state.methods = payload;
  },
};

const actions = {
  getReceiptList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `employee/receipt/list?page=${state.page}&view=${rootState.Main.view}${payload ? payload : ""}`
        )
        .then((response) => {
          commit("SET_RECEIPT_LIST", response.data);
          commit("SET_LOADING", false);
          resolve(response.data);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  getReceiptLog({ commit, dispatch }, receiptNumber) {
    commit("SET_LOADING_LOG", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`employee/receipt/log?receipt_number=${receiptNumber}`)
        .then((response) => {
          commit("SET_RECEIPT_LOG", response.data.data);
          commit("SET_LOADING_LOG", false);
          resolve(response.data.data);
        })
        .catch((error) => {
          commit("SET_LOADING_LOG", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  async createReceipt({ commit, dispatch }, form) {
    commit("SET_CREATE_LOAD", true);
    try {
      // buat payload JSON biasa (bukan FormData)
      const now = new Date();
      const formattedDate = now.getFullYear() + "-"
        + String(now.getMonth() + 1).padStart(2, "0") + "-"
        + String(now.getDate()).padStart(2, "0") + " "
        + String(now.getHours()).padStart(2, "0") + ":"
        + String(now.getMinutes()).padStart(2, "0") + ":"
        + String(now.getSeconds()).padStart(2, "0");

      const payload = {
        to: form.to,
        subject: form.subject,
        description: form.description || "",
        date: formattedDate,
        shipped_by: form.shipped_by || null,
        shipped_date: form.shipped_date || null,
        documents: form.documents.map((doc) => ({
          title: doc.title || "",
          note: doc.note || null,
          file: doc.file || null,
          original_name: doc.original_name || null
        }))
      };

      const res = await $axios.post("employee/receipt/create", payload, {
        headers: { "Content-Type": "application/json" }
      });

      commit("SET_CREATE_LOAD", false);

      dispatch("Main/globalSweetAlert", {
        data: res.data,
        status: res.status,
      }, { root: true });

      return res.data;
    } catch (err) {
      commit("SET_CREATE_LOAD", false);

      if (err.response) {
        dispatch("Main/globalSweetAlert", {
          status: err.response.status,
          data: err.response.data || { message: "Payload too large" },
        }, { root: true });
      } else {
        dispatch("Main/globalSweetAlert", {
          status: 0,
          data: { message: err.message || "Network error" },
        }, { root: true });
      }

      throw err;
    }
  },
  async getReceiptById({ commit, dispatch }, id) {
    commit("SET_LOADING_FETCH", true);
    try {
      const res = await $axios.get(`employee/receipt/edit/${id}`);
      commit("SET_LOADING_FETCH", false);
      return res.data.data;
    } catch (err) {
      commit("SET_LOADING_FETCH", false);
      dispatch("Main/globalSweetAlert", err.response, { root: true });
      throw err;
    }
  },
  updateReceipt({ dispatch }, { id, payload }) {
    return new Promise((resolve, reject) => {
      // Bersihkan payload (hapus key kosong/null/undefined)
      const clean = {};
      Object.entries(payload).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== "") clean[k] = v;
      });

      // Kirim PUT request langsung (JSON body)
      $axios.put(`employee/receipt/update/${id}`, clean)
        .then((response) => {
          dispatch(
            "Main/globalSweetAlert",
            { data: response.data, status: response.status },
            { root: true }
          );
          resolve(response.data);
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  async selectStatus({ commit, dispatch }) {
    try {
      const res = await $axios.get(`employee/receipt/select/status`);
      commit("SET_STATUS_LIST", res.data.data);
      return res.data.data;
    } catch (err) {
      dispatch("Main/globalSweetAlert", err.response, { root: true });
      throw err;
    }
  },
  async selectMethod({ commit, dispatch }) {
    try {
      const res = await $axios.get(`employee/receipt/select/send-method`);
      commit("SET_METHODS", res.data.data);
      return res.data.data;
    } catch (err) {
      dispatch("Main/globalSweetAlert", err.response, { root: true });
      throw err;
    }
  },
  showhide({ commit, state, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios.post(`employee/receipt/showhide`, payload)
        .then((response) => {
          commit("SET_SUCCESS", true);
          dispatch('Main/globalSuccessSweetAlert', response.data.message, { root: true });
          resolve(response); // <-- penting
        })
        .catch((error) => {
          commit("SET_SUCCESS", false);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error); // <-- penting
        });
    });
  },

  async backupReceiptRange({ commit, dispatch }, { start_date, end_date, confirm_delete }) {
    commit("SET_BACKUP_LOADING", true);
    try {
      const res = await $axios.post(
        `employee/receipt/backup/range`,
        { start_date, end_date, confirm_delete },
        { responseType: "blob" }
      );

      // cek apakah responsenya JSON error
      if (res.data instanceof Blob && res.data.type === "application/json") {
        const text = await res.data.text();
        const json = JSON.parse(text);

        dispatch("Main/globalSweetAlert", {
          status: 400,
          data: json
        }, { root: true });

        return json; // <-- biar component bisa cek success:false
      }

      // kalau berhasil ZIP → simpan
      const filename = `backup_receipts_${start_date}_to_${end_date}.zip`;
      FileSaver.saveAs(res.data, filename);

      dispatch("Main/globalSuccessSweetAlert", "Backup berhasil dibuat", { root: true });
      return { success: true };

    } catch (err) {
      dispatch("Main/globalSweetAlert", err.response || {
        status: 500,
        data: { message: "Gagal membuat backup" }
      }, { root: true });
      throw err;
    } finally {
      commit("SET_BACKUP_LOADING", false);
    }
  }

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
